import * as React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ReportsLayout } from './ReportsLayout';
import { Report1Page } from './Report1/Report1Page';
import { Report2Page } from './Report2/Report2Page';
import { Report3Page } from './Report3/Report3Page';

@observer
class ReportsRouterComponent extends React.Component<any, any> {
    render() {
        return (
            <ReportsLayout>
                {/* <Route path='/' component={CustomerOrdersPage} /> */}
                <Route path='/reports/report1' component={Report1Page} />
                <Route path='/reports/report2' component={Report2Page} />
                <Route path='/reports/report3/:page?' component={Report3Page} />
            </ReportsLayout>
        );
    }
}

const ReportsRouter = withRouter(ReportsRouterComponent)
export default ReportsRouter;